/*
 * @Description: 图片容器
 */
import React, { useEffect, useState } from 'react';
import cx from 'classnames';
import { processImg } from 'utils/processImg';
import PropTypes from 'prop-types';
import './index.less';

/**
 * ImgWrap组件
 * 用于处理图片的展示，支持圆角、背景色、宽度和高度的设置。
 * 相当于原本装饰器用法 对props修改方法在这里处理转换
 *
 * @param {String} src 图片src 必填
 * @param {String} [mode='full'] 图片模式 可选值为full | whole | discard 默认为full
 * @param {String} [w='auto'] 图片宽度 默认为auto
 * @param {String} [h='auto'] 图片高度 默认为auto
 * @param {String} [r=0] 图片圆角 默认为0
 * @param {String} [bg='none'] 图片背景 默认为none
 * @param {String} [className=''] 图片自定义类名 默认为空
 * @param {Object} [imgStyle={}] 图片自定义样式 默认为空
 */
const ImgWrap = (props) => {
  const [Mode, transFormMode] = useState(props.mode);
  const modeList = ['full', 'whole', 'discard', 'cover'];

  useEffect(() => {
    if (!modeList.includes(Mode)) {
      transFormMode('full');
    }
  }, [props]);

  return <Dom {...props} mode={Mode} />;
};

const Dom = (props) => {
  const { src, mode, w, h, r, bg, className, imgStyle, style } = props;
  return (
    <div
      className={cx('linchen-imgwrap', mode, className)}
      style={{ width: w, height: h, borderRadius: r, background: bg, ...style }}>
      <img src={processImg(src)} style={imgStyle} loading="lazy" />
    </div>
  );
};

// defaultProps
ImgWrap.defaultProps = {
  mode: 'full',
  w: 'auto',
  h: 'auto',
  r: 0,
  bg: 'none',
  className: '',
  imgStyle: {},
  style: {}
};

// PropTypes
ImgWrap.propTypes = {
  src: PropTypes.string.isRequired, // 图片src 必填
  mode: PropTypes.oneOf(['full', 'whole', 'discard', 'cover']), // 图片模式 默认为full
  w: PropTypes.any, // 图片宽度 默认为auto
  h: PropTypes.any, // 图片高度 默认为auto
  r: PropTypes.any, // 图片圆角 默认为0
  bg: PropTypes.any, // 图片背景 默认为none
  className: PropTypes.string, // 图片自定义类名 默认为空
  imgStyle: PropTypes.object, // 图片自定义样式 默认为空
  style: PropTypes.object // 图片自定义样式 默认为空
};

export default ImgWrap;



// WEBPACK FOOTER //
// ./src/pubBiz/ImgWrap/index.js